import React, { useState, Fragment } from "react"
import { FaCaretDown, FaCaretUp } from "react-icons/fa6"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { IconButton } from "components"
import InventoryRowVariant from "./InventoryRowVariant"
import classes from "./InventoryRowVariants.module.scss"

const InventoryRowVariants = props => {
  const { food } = props

  const i18n = useTranslation()[1]

  const [openCollapse, setOpenCollapse] = useState(false)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <tr
        className={clsx(
          classes["container"],
          openCollapse && classes["remove-border"]
        )}
      >
        <td
          className={clsx(
            classes["cell"],
            classes["code"],
            isLtr && classes["code-ltr"]
          )}
        >
          {food.code}
        </td>

        <td className={clsx(classes["cell"], classes["name"])}>
          {food.name}
        </td>

        <td className={clsx(classes["cell"], classes["stockManagement"])} />

        <td className={clsx(classes["cell"], classes["outOfStock"])} />

        <td className={clsx(classes["cell"], classes["inventory"])}>
          <IconButton
            color="var(--color-primary)"
            size={25}
            className={classes["button"]}
            icon={openCollapse ? FaCaretUp : FaCaretDown}
            onClick={() => setOpenCollapse(prev => !prev)}
          />
        </td>
      </tr>

      {
        openCollapse &&
        food.options.map((option, oIndex) =>
          <InventoryRowVariant
            key={option._id}
            food={food}
            option={option}
            lastIndex={food.options.length - 1 === oIndex}
          />
        )
      }
    </Fragment>
  )
}

export default React.memo(InventoryRowVariants)